module.exports = {
  vsDomain: 'weightwatchers.com',
  signupApiUrl: 'https://api1{env}weightwatchers.com/signup/',
};
